import React from "react";
import { Box, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "components/basic/modal";
import Typography from "components/basic/typography";

import GoogleReviewPanel from "./components/GoogleReviewPanel";
import VendorAdminActions from "./components/VendorAdminActions";
import VendorProfile from "./components/VendorProfile";
import VendorStatusBadges from "../VendorStatusBadges";
import { AdminVendor } from "../../../../types";

interface VendorDetailProps {
  vendor: AdminVendor;
  onChanged: () => void;
  onClose: () => void;
}

const VendorDetail: React.FC<VendorDetailProps> = ({
  vendor,
  onChanged,
  onClose,
}) => (
  <Modal onClose={onClose}>
    <Box
      sx={{
        width: { xs: "min(360px, 100vw - 64px)", sm: 560, md: 720 },
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box display="flex" alignItems="flex-start" gap={1}>
        <Box flexGrow={1} minWidth={0}>
          <Typography variant="h4" style={{ fontWeight: "bold" }}>
            {vendor.vendor.businessName}
          </Typography>
          {vendor.vendor.operatingAs && (
            <Typography variant="body2">
              Operating as {vendor.vendor.operatingAs}
            </Typography>
          )}
          <Box mt={1}>
            <VendorStatusBadges vendor={vendor} />
          </Box>
        </Box>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>

      <VendorAdminActions vendor={vendor} onChanged={onChanged} />
      <GoogleReviewPanel vendor={vendor} onChanged={onChanged} />
      <Divider />
      <VendorProfile vendor={vendor} />
    </Box>
  </Modal>
);

export default VendorDetail;
